import { render, staticRenderFns } from "./ratingType.vue?vue&type=template&id=23af4378"
import script from "./ratingType.vue?vue&type=script&lang=js"
export * from "./ratingType.vue?vue&type=script&lang=js"
import style0 from "./ratingType.vue?vue&type=style&index=0&id=23af4378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports